import React from "react";

const Footer: React.FC = () => {
  return <footer style={{ height: 80 }}></footer>;
};

export default Footer;
